import React from 'react';
import { Col, Row } from '@ag1/ui';
import FooterConnect from '../FooterConnect/FooterConnect';
import FooterLogoSection from '../FooterLogoSection/FooterLogoSection';
import FooterControls from '../FooterControls/FooterControls';
import FooterDisclaimer from '../FooterDisclaimer/FooterDisclaimer';
import FooterDivider from '../FooterDivider/FooterDivider';
import FooterBottomMenu from '../FooterBottomMenu/FooterBottomMenu';
import styles from './styles.module.scss';
import FooterCopyright from '../FooterCopyright/FooterCopyright';
import FooterSocial from '../FooterSocial/FooterSocial';

const FooterContentLander = () => (
  <div className={styles.root}>
    <Row className={styles.topRow}>
      <Col
        span={{ xxs: 12, s: 8, m: 4, l: 'auto' }}
        offset={{ s: 2, m: 4, l: 0 }}
        className={styles.connectSection}>
        <div className={styles.connectSectionContent}>
          <div className={styles.connectSectionControls}>
            <FooterControls />
          </div>
          <FooterConnect />
        </div>
      </Col>
      <Col span={{ xxs: 12, l: 'auto' }} className={styles.logoSection}>
        <div className={styles.logoSectionContent}>
          <FooterLogoSection />
        </div>
      </Col>
      <Col span={12} className={styles.divider}>
        <FooterDivider />
      </Col>
      <Col span={12} className={styles.controlsSection}>
        <FooterControls />
      </Col>
      <Col span={12} className={styles.divider}>
        <FooterDivider />
      </Col>
      <Col
        span={{ xxs: 12, m: 8, l: 'auto' }}
        offset={{ m: 2, l: 0 }}
        className={styles.disclaimerSection}>
        <div className={styles.disclaimerSectionContent}>
          <FooterDisclaimer />
        </div>
      </Col>
    </Row>
    <Row className={styles.bottomRow}>
      <Col className={styles.copyrightSection}>
        <div className={styles.copyrightSectionContent}>
          <FooterCopyright />
        </div>
      </Col>
      <Col className={styles.menuSection}>
        <div className={styles.menuSectionContent}>
          <FooterBottomMenu />
        </div>
      </Col>
      <Col className={styles.socialSection}>
        <FooterSocial />
      </Col>
    </Row>
  </div>
);

export default FooterContentLander;
